// This file is automatically generated by webgen from the struct descriptions in /generated-json/structs.
// Files in /generated-json are created from the structs configured in the 'main' function of /cmd/struct2json/main.go.
//
// DO NOT EDIT THIS FILE except where designated below.

/* eslint-disable no-relative-import-paths/no-relative-import-paths */

import type { DateTime } from 'luxon';
import type { PartialDeep } from 'type-fest';

import * as DateHelpers from '../../../utils/dateHelpers';
import type { ExcludeMethodsDeep } from '../../../utils/types';
import { NIL_UUID } from '../../../utils/uuid';

export class CompetitorSummary {
  readonly id: string;
  readonly name: string;
  readonly plants: string | null;
  readonly products: string | null;
  readonly isArchived: boolean;
  readonly updatedAt: DateTime;

  constructor(data: { [key: string]: any } = {}) {
    this.id = data.id === undefined ? NIL_UUID : data.id;
    this.name = data.name === undefined ? '' : data.name;
    this.plants = data.plants === undefined ? null : data.plants;
    this.products = data.products === undefined ? null : data.products;
    this.isArchived = data.isArchived === undefined ? false : data.isArchived;
    this.updatedAt = DateHelpers.ParseServerDateTime(data.updatedAt);
  }

  static zero(): CompetitorSummary {
    const zeroValues: ExcludeMethodsDeep<CompetitorSummary> = {
      id: NIL_UUID,
      name: '',
      plants: null,
      products: null,
      isArchived: false,
      updatedAt: DateHelpers.ParseServerDateTime(DateHelpers.ZERO_DATE_STRING),
    };
    return new CompetitorSummary(zeroValues);
  }

  // ************* DO NOT EDIT ABOVE THIS LINE *************
  // ************* DO NOT EDIT BELOW THIS LINE *************
}

export type CompetitorSummaryWireFormat = {
  id: string;
  name: string;
  plants: string | null;
  products: string | null;
  isArchived: boolean;
  updatedAt: string;
};

type NewCompetitorSummaryProps = PartialDeep<CompetitorSummary, { recurseIntoArrays: true }>;
export const NewCompetitorSummary: (props: NewCompetitorSummaryProps) => CompetitorSummary = (
  props,
) => new CompetitorSummary(props);

type NewCompetitorSummaryFromWireFormatProps = PartialDeep<
  CompetitorSummaryWireFormat,
  { recurseIntoArrays: true }
>;
export const NewCompetitorSummaryFromWireFormat: (
  props: NewCompetitorSummaryFromWireFormatProps,
) => CompetitorSummary = (props) => new CompetitorSummary(props);
